// ---------------------------------------------------------------------------
// Idioma de la app (es/en). La CLAVE de cada texto es el propio texto en español:
//   t('Guardar')                       → 'Save' en inglés
//   t('Hola {0}, tienes {1}', [a, b])  → interpola en ambos idiomas
// Lo que no esté en i18n.en.js sale en español (nunca un hueco).
//
// El idioma se elige en el Onboarding (negocio y demo) y en Ajustes, se guarda en
// este navegador y cambiarlo RECARGA la página: hay textos que se evalúan al importar
// (pasos del recorrido, menús), así no queda ninguno a medias.
// ---------------------------------------------------------------------------
import en from './i18n.en.js';

const KEY = 'soedia:lang';

/**
 * Soedia se enfoca en México: el cambio de idioma (ES ⇄ EN) está ESCONDIDO y la app
 * siempre sale en español. Las traducciones (i18n.en.js) y los botones siguen en el
 * código; poner `true` aquí los vuelve a mostrar en todos lados (Login, Ajustes,
 * Onboarding, demo, Super Admin) y respeta otra vez el idioma guardado.
 */
export const LANGUAGE_SWITCH = false;
export const LANGS = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' },
];

function readLang() {
  if (!LANGUAGE_SWITCH) return 'es';
  try {
    const v = globalThis.localStorage?.getItem(KEY);
    if (v === 'es' || v === 'en') return v;
  } catch {
    /* almacenamiento bloqueado: idioma por defecto */
  }
  return 'es';
}

export const lang = readLang();
/** Locale de fechas (el dinero sigue con el formato de su moneda). */
export const locale = lang === 'en' ? 'en-US' : 'es-MX';
if (typeof document !== 'undefined') document.documentElement.lang = lang;

/** Busca el texto en el idioma activo (inglés o español) y lo devuelve. */
export function t(text, args) {
  let out = lang === 'en' ? (en[text] ?? text) : text;
  if (args) out = out.replace(/\{(\d+)\}/g, (m, i) => (args[i] ?? m));
  return out;
}

/** Guarda el idioma y recarga si cambió. */
export function setLang(code) {
  if (code === lang) return;
  try {
    localStorage.setItem(KEY, code);
  } catch {
    return;
  }
  location.reload();
}
